module.exports = __webpack_public_path__ + "img/workout-notebook_B095GRW8PV.f6cc8c20.jpg";